import 'select2';
import 'select2/dist/css/select2.min.css';
import {$win} from '../app/globals';

const initBlock = ( $block ) => {
	if ( $( '.js-select2' ).length ) {
		const $selects = $( '.js-select2' );
		$selects.select2( {
			minimumResultsForSearch: 10,
			dropdownParent: $block.find( '.shop-search-sort' ),
		} );

		$selects.on( 'select2:open', function() {
			$( '.select2-search input' ).prop( 'focus', false );
		} );
	}

	const initFilterDropdowns = () => {
		const $dropdowns = $block.find( '.js-filter-dropdown' );

		const setDropdownState = ( $dropdown, isOpen ) => {
			const $body = $dropdown.find( '.wpc-filter-body' );
			if ( !$body.length ) {
				return;
			}

			if ( isOpen ) {
				$dropdown.addClass( 'is-open' );
				const bodyEl = $body.get( 0 );
				const contentHeight = bodyEl ? bodyEl.scrollHeight : 0;
				$body.css( 'max-height', contentHeight );
			} else {
				$dropdown.removeClass( 'is-open' );
				$body.css( 'max-height', 0 );
			}
		};

		$dropdowns.each( function() {
			const $dropdown = $( this );
			const $toggle = $dropdown.find( '.js-filter-dropdown-toggle' );

			const isMobile = window.innerWidth <= 1024;

			setDropdownState( $dropdown, !isMobile );

			$toggle.on( 'click', function( e ) {
				e.preventDefault();
				setDropdownState( $dropdown, !$dropdown.hasClass( 'is-open' ) );
			} );
		} );

		let resizeTimer = null;
		$win.off( 'resize.ourShopFilters' ).on( 'resize.ourShopFilters', function() {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( function() {
				const isMobile = window.innerWidth <= 1024;
				$dropdowns.each( function() {
					const $dropdown = $( this );
					if ( isMobile ) {
						setDropdownState( $dropdown, false );
						return;
					}

					setDropdownState( $dropdown, true );
				} );
			}, 250 );
		} );
	};

	initFilterDropdowns();

	const selectors = {
		categoryCheckbox: 'input[name="product_cat[]"]',
		tagCheckbox: 'input[name="product_tag[]"]',
		resetButton: '.wpc-reset-filters',
		termLink: '.wpc-term-link',
		searchInput: '#shop-search',
	};

	const categoryCheckboxes = $block.find( selectors.categoryCheckbox );
	const tagCheckboxes = $block.find( selectors.tagCheckbox );
	const resetButton = $block.find( selectors.resetButton );
	const sortSelect = $block.find( '.shop-search-sort select[name="orderby"]' );
	const searchInput = $block.find( selectors.searchInput );

	const getSelectedFromURL = () => {
		const params = new URLSearchParams( window.location.search );
		return {
			cats: params.get( 'product_cat' )?.split( ',' ) || [],
			tags: params.get( 'product_tag' )?.split( ',' ) || [],
		};
	};

	const getSelectedValues = ( $checkboxes ) =>
		$checkboxes
			.filter( ':checked' )
			.map( function() { return this.value; } )
			.get()
			.join( ',' );

	const updateURL = () => {
		const url = new URL( window.location.href );
		const selectedCategories = getSelectedValues( categoryCheckboxes );
		const selectedTags = getSelectedValues( tagCheckboxes );

		updateQueryParam( url, 'product_cat', selectedCategories );
		updateQueryParam( url, 'product_tag', selectedTags );

		saveScrollPosition();
		window.location.href = url.toString();
	};

	const updateQueryParam = ( url, key, value ) => {
		if ( value ) {
			url.searchParams.set( key, value );
		} else {
			url.searchParams.delete( key );
		}
	};

	const restoreCheckedState = () => {
		const { cats, tags } = getSelectedFromURL();

		categoryCheckboxes.each( function() {
			this.checked = cats.includes( this.value );
		} );

		tagCheckboxes.each( function() {
			this.checked = tags.includes( this.value );
		} );
	};

	const saveScrollPosition = () => {
		localStorage.setItem( 'shopScrollPosition', window.scrollY );
	};

	const restoreScrollPosition = () => {
		const savedPosition = localStorage.getItem( 'shopScrollPosition' );
		if ( savedPosition ) {
			window.scrollTo( 0, parseInt( savedPosition, 10 ) );
			localStorage.removeItem( 'shopScrollPosition' );
		}
	};

	const resetFilters = ( e ) => {
		e.preventDefault();
		saveScrollPosition();

		categoryCheckboxes.prop( 'checked', false );
		tagCheckboxes.prop( 'checked', false );

		const baseUrl = `${ window.location.origin }${ window.location.pathname }`;
		window.location.href = baseUrl;
	};

	const toggleCheckboxOnClick = ( e ) => {
		e.preventDefault();
		const $checkbox = $( e.currentTarget )
			.closest( '.wpc-term-item-content-wrapper' )
			.find( 'input[type="checkbox"]' );

		$checkbox.prop( 'checked', !$checkbox.prop( 'checked' ) ).trigger( 'change' );
	};

	const handleSortChange = ( e ) => {
		e.preventDefault();

		const url = new URL( window.location.href );
		const orderByValue = sortSelect.val();

		url.searchParams.set( 'orderby', orderByValue );

		localStorage.setItem( 'shopScrollPosition', window.scrollY );

		window.location.href = url.toString();
	};

	const handleSearchInput = () => {
		const value = searchInput.val().trim();
		const url = new URL( window.location.href );

		if ( value.length >= 2 ) {
			url.searchParams.set( 'srch', value );
		} else {
			url.searchParams.delete( 'srch' );
		}

		saveScrollPosition();
		window.location.href = url.toString();
	};

	searchInput.on( 'keydown', function( e ) {
		if ( e.key === 'Enter' ) {
			e.preventDefault();
			handleSearchInput();
		}
	} );

	sortSelect.on( 'change', handleSortChange );

	restoreCheckedState();
	restoreScrollPosition();

	categoryCheckboxes.add( tagCheckboxes ).on( 'change', updateURL );
	resetButton.on( 'click', resetFilters );
	$block.find( selectors.termLink ).on( 'click', toggleCheckboxOnClick );
};

app.loadBlock( initBlock, 'our-shop', '.section-our-shop' );

if ( module.hot ) {
	module.hot.accept();
}
